import { OptionsType } from '@europrocurement/flexy-components';
import { FormStructure } from '@europrocurement/flexy-form';
import { documentTypes } from '@europrocurement/l2d-domain';

export const boolOptions = [
    { value: true, label: 'Oui' },
    { value: false, label: 'Non' },
];

type GridConfig = {
    xs?: number;
    sm?: number;
    md?: number;
    lg?: number;
};

type BooleanFieldConfig = {
    name: string;
    inputlabel: string;
    placeholder: string;
    grid?: GridConfig;
};

export const docStatusChoices: OptionsType = [
    { value: 7, label: 'A vérifier' },
    { value: 9, label: 'Validé' },
    { value: 43, label: 'Non attribué' },
];

export const getDocumentTypeMainFields = (): FormStructure[] => [
    {
        type: 'text',
        name: 'libelle',
        inputlabel: 'Libellé',
        rules: {
            required: 'Vous devez renseigner un libellé',
        },
        placeholder: 'Le libellé du type de document',
    },
    {
        type: 'text',
        name: 'name',
        inputlabel: 'Nom interne',
        placeholder: 'Nom technique du type de document',
    },
    {
        type: 'select',
        name: 'type',
        inputlabel: 'Type',
        options: [...documentTypes],
        getOptionLabel: ({ label }: { label: string }) => label,
        getOptionValue: ({ value }: { value: number }) => value.toString(),
        placeholder: 'Veuillez sélectionner un type',
        rules: {
            required: 'Vous devez sélectionner un type',
        },
    },
    {
        type: 'text',
        name: 'libelleDF',
        inputlabel: 'Libellé Dématfacile',
        placeholder: 'Libellé Dématfacile',
    },
    {
        type: 'text',
        name: 'help',
        inputlabel: "Texte d'aide",
        placeholder: "Texte d'aide affiché à l'utilisateur",
    },
    {
        type: 'select',
        name: 'statut',
        inputlabel: "Statut par défaut a l'ajout du document",
        options: docStatusChoices,
        placeholder: 'Veuillez sélectionner un statut',
    },
];

export const getBooleanField = ({
    name,
    inputlabel,
    placeholder,
    grid,
}: BooleanFieldConfig): FormStructure => ({
    type: 'select',
    name,
    inputlabel,
    options: boolOptions,
    placeholder,
    ...grid,
});
